module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<fieldset class="youtube-properties">\n    <legend class="collapsible collapsed" data-toggle="collapse" data-target=".youtube-properties-accordion">\n        <div class="youtube-menu-icon" />&nbsp;YouTube Widget\n    </legend>\n    <div class="youtube-properties-accordion collapse collapse-target">\n        <div>\n            <input class="search header" type="search" placeholder="Search" maxlength="40">\n            <div class="youtube-results"></div>\n        </div>\n        <div class="account-view-region"></div>\n        <div class="youtube-settings-properties"></div>\n    </div>\n</fieldset>\n\n<fieldset>\n    <div class="animation-properties"></div>\n    <div class="size-and-position-properties"></div>\n</fieldset>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/youtubeWidget/YouTubeWidgetPropertiesView.tpl
// module id = 2074
// module chunks = 0